(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["center-stone-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('center-stone-carousel')) {
    class CenterStoneCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-carousel-track]');
        this.previousButton = this.querySelector('[data-carousel-previous]');
        this.nextButton = this.querySelector('[data-carousel-next]');
        this.dots = this.querySelector('[data-carousel-dots]');

        if (!this.track || !this.previousButton || !this.nextButton) return;

        this.previousButton.addEventListener('click', () => this.move(-1));
        this.nextButton.addEventListener('click', () => this.move(1));
        this.track.addEventListener('scroll', () => this.requestUpdate(), { passive: true });

        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.track);
        this.update();
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      move(direction) {
        const distance = Math.max(this.track.clientWidth * 0.85, 180);
        this.track.scrollBy({ left: distance * direction, behavior: 'smooth' });
      }

      requestUpdate() {
        if (this.updateFrame) cancelAnimationFrame(this.updateFrame);
        this.updateFrame = requestAnimationFrame(() => this.update());
      }

      update() {
        const maximum = Math.max(this.track.scrollWidth - this.track.clientWidth, 0);
        const current = Math.max(this.track.scrollLeft, 0);
        const pageCount = Math.max(Math.ceil(this.track.scrollWidth / this.track.clientWidth), 1);
        const activePage = maximum === 0 ? 0 : Math.round((current / maximum) * (pageCount - 1));

        this.previousButton.disabled = current <= 2;
        this.nextButton.disabled = current >= maximum - 2;

        if (this.dots && this.dots.children.length !== pageCount) {
          this.dots.replaceChildren();
          for (let index = 0; index < pageCount; index += 1) {
            const dot = document.createElement('span');
            dot.className = 'center-stone-carousel__dot';
            this.dots.appendChild(dot);
          }
        }

        if (this.dots) {
          Array.from(this.dots.children).forEach((dot, index) => {
            dot.classList.toggle('is-active', index === activePage);
          });
        }
      }
    }

    customElements.define('center-stone-carousel', CenterStoneCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection-showcase"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-showcase-prev], [data-showcase-next]');
    if (!button) return;
    const section = button.closest('[data-section-id]');
    const track = section?.querySelector('[data-showcase-track]');
    if (!track) return;
    const direction = button.hasAttribute('data-showcase-next') ? 1 : -1;
    track.scrollBy({ left: direction * track.clientWidth * 0.72, behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fym-custom-inquiry"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.fym-custom-inquiry__file-input').forEach((input) => {
    input.addEventListener('change', () => {
      const name = input.parentElement.querySelector('.fym-custom-inquiry__file-name');
      if (!name) return;
      name.textContent = input.files && input.files.length
        ? input.files[0].name
        : name.dataset.emptyLabel;
    });
  });

  const enhanceFymForms = (root) => {
    const form = root.querySelector('form');
    if (!form || form.dataset.fymEnhanced === 'true') return;

    form.dataset.fymEnhanced = 'true';
    form.classList.add('fym-forms-grid');

    root.querySelectorAll('h1, h2, h3, p').forEach((element) => {
      if (form.contains(element)) return;
      const copy = element.textContent.trim().replace(/\s+/g, ' ');
      if (
        copy === 'Tell Us What You Imagine' ||
        copy.startsWith('Share as much or as little as you have.')
      ) {
        element.hidden = true;
      }
    });

    const controls = Array.from(
      form.querySelectorAll('input:not([type="hidden"]):not([type="submit"]), select, textarea')
    );

    const fieldContainers = [];
    controls.forEach((control) => {
      let node = control.parentElement;
      let candidate = node;

      while (node && node !== form) {
        const labels = node.querySelectorAll('label').length;
        const fields = node.querySelectorAll(
          'input:not([type="hidden"]):not([type="submit"]), select, textarea'
        ).length;

        if (labels <= 1 && fields >= 1) candidate = node;
        if (labels > 1) break;
        node = node.parentElement;
      }

      if (candidate && candidate !== form && !fieldContainers.includes(candidate)) {
        fieldContainers.push(candidate);
      }
    });

    fieldContainers.forEach((field) => {
      field.classList.add('fym-forms-field');
      if (field.querySelector('textarea')) field.classList.add('fym-forms-field--full');
    });

    const submit = form.querySelector('button[type="submit"], input[type="submit"]');
    if (submit) {
      let submitContainer = submit.parentElement;
      while (
        submitContainer.parentElement &&
        submitContainer.parentElement !== form &&
        submitContainer.parentElement.querySelectorAll('button[type="submit"], input[type="submit"]').length === 1
      ) {
        submitContainer = submitContainer.parentElement;
      }
      if (submitContainer !== form) submitContainer.classList.add('fym-forms-submit');
    }
  };

  document.querySelectorAll('.fym-custom-inquiry__forms-app').forEach((root) => {
    enhanceFymForms(root);
    const observer = new MutationObserver(() => enhanceFymForms(root));
    observer.observe(root, { childList: true, subtree: true });
  });

  const fymFormsPlaceholderLabels = {
    'Your Name': {
      label: 'Your Name',
      placeholder: 'Your full name'
    },
    'Your Email': {
      label: 'Your Email',
      placeholder: 'yourname@email.com'
    },
    'Your Budget Range': {
      label: 'Your Budget Range',
      placeholder: 'For example, $1,000–$2,000'
    },
    'Preferred Gemstones': {
      label: 'Preferred Gemstones',
      placeholder: 'Tell us which stones speak to you'
    },
    'Ring Size': {
      label: 'Ring Size',
      placeholder: 'Enter a size or say not sure'
    },
    'Anything Else You Would Like to Share': {
      label: 'Anything Else You Would Like to Share',
      placeholder: 'Describe the feeling, details or story behind your ring'
    }
  };

  const getFymFormsRoots = (startRoot) => {
    const roots = [startRoot];
    const queue = [startRoot];

    while (queue.length) {
      const currentRoot = queue.shift();
      currentRoot.querySelectorAll('*').forEach((element) => {
        if (element.shadowRoot && !roots.includes(element.shadowRoot)) {
          roots.push(element.shadowRoot);
          queue.push(element.shadowRoot);
        }

        if (element.tagName === 'IFRAME') {
          try {
            const frameRoot = element.contentDocument;
            if (frameRoot && !roots.includes(frameRoot)) {
              roots.push(frameRoot);
              queue.push(frameRoot);
            }
          } catch (error) {
            // Cross-origin frames cannot be styled from the theme.
          }
        }
      });
    }

    return roots;
  };

  const addFymFormsLabels = () => {
    document.querySelectorAll('.fym-custom-inquiry__forms-app').forEach((appRoot) => {
      getFymFormsRoots(appRoot).forEach((root) => {
        root.querySelectorAll('input[placeholder], textarea[placeholder]').forEach((field) => {
          const fieldCopy = field.getAttribute('placeholder') || '';
          const config = fymFormsPlaceholderLabels[fieldCopy];
          if (!config || field.dataset.fymLabelAdded === 'true') return;

          const label = document.createElement('label');
          const fieldId = field.id || 'fym-forms-field-' + Math.random().toString(36).slice(2);
          field.id = fieldId;
          field.dataset.fymLabelAdded = 'true';
          label.htmlFor = fieldId;
          label.textContent = config.label;
          label.dataset.fymGeneratedLabel = 'true';
          label.style.display = 'block';
          label.style.width = '100%';
          label.style.margin = '0 0 8px';
          label.style.color = '#3e4f35';
          label.style.fontFamily = '"Work Sans", Arial, sans-serif';
          label.style.fontSize = '12px';
          label.style.fontWeight = '500';
          label.style.lineHeight = '20px';
          label.style.letterSpacing = '.12em';
          label.style.textAlign = 'left';
          label.style.textTransform = 'uppercase';

          const fieldParent = field.parentElement;
          if (fieldParent) {
            fieldParent.insertBefore(label, field);
          }

          field.setAttribute('placeholder', config.placeholder);
        });
      });
    });
  };

  addFymFormsLabels();
  let fymFormsLabelAttempts = 0;
  const fymFormsLabelTimer = window.setInterval(() => {
    addFymFormsLabels();
    fymFormsLabelAttempts += 1;
    if (fymFormsLabelAttempts >= 40) window.clearInterval(fymFormsLabelTimer);
  }, 500);

  const openFymShopifyChat = () => {
    const agentHost =
      document.querySelector('shopify-chat') ||
      document.querySelector('shopify-agent');

    if (agentHost && typeof agentHost.show === 'function') {
      agentHost.show();
      return true;
    }

    const legacyHosts = Array.from(
      document.querySelectorAll('inbox-online-store-chat')
    );

    for (const outerHost of legacyHosts) {
      const chatHost =
        outerHost.id === 'ShopifyChat'
          ? outerHost
          : outerHost.shadowRoot?.querySelector('#ShopifyChat');

      if (!chatHost || !chatHost.shadowRoot) continue;

      const chatToggle = chatHost.shadowRoot.querySelector(
        'button.chat-toggle, button[data-spec="toggle-button"], .chat-app > button'
      );

      if (!chatToggle) continue;
      chatToggle.click();
      return true;
    }

    const oldChatHost = document.getElementById('ShopifyChat');
    const oldChatToggle = oldChatHost?.shadowRoot?.querySelector(
      'button.chat-toggle, button[data-spec="toggle-button"], .chat-app > button'
    );

    if (!oldChatToggle) return false;
    oldChatToggle.click();
    return true;
  };

  document.querySelectorAll('[data-fym-open-chat]').forEach((chatButton) => {
    if (chatButton.dataset.fymChatReady === 'true') return;
    chatButton.dataset.fymChatReady = 'true';

    chatButton.addEventListener('click', (event) => {
      event.preventDefault();

      if (openFymShopifyChat()) return;

      let attempts = 0;
      const chatTimer = window.setInterval(() => {
        attempts += 1;

        if (openFymShopifyChat() || attempts >= 20) {
          window.clearInterval(chatTimer);
        }
      }, 250);
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["happy-customers-videos"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeVideoSliders = (root = document) => {
      root.querySelectorAll('.fym-video-slider').forEach((slider) => {
        if (slider.dataset.sliderReady === 'true') return;
        slider.dataset.sliderReady = 'true';

        const track = slider.querySelector('[data-video-slider-track]');
        const previous = slider.querySelector('[data-video-slider-prev]');
        const next = slider.querySelector('[data-video-slider-next]');
        if (!track) return;

        const getStep = () => {
          const card = track.querySelector('.fym-video-slider__card');
          if (!card) return track.clientWidth;
          const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          return card.getBoundingClientRect().width + gap;
        };

        const updateButtons = () => {
          if (previous) previous.disabled = track.scrollLeft <= 2;
          if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        };

        previous?.addEventListener('click', () => {
          track.scrollBy({ left: -getStep(), behavior: 'smooth' });
        });

        next?.addEventListener('click', () => {
          track.scrollBy({ left: getStep(), behavior: 'smooth' });
        });

        track.addEventListener('scroll', updateButtons, { passive: true });
        window.addEventListener('resize', updateButtons);
        updateButtons();
      });
    };

    initializeVideoSliders();
    document.addEventListener('shopify:section:load', (event) => initializeVideoSliders(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-guide-grid"] && !Shopify.designMode) return;
  try {
    
  const guideMobileQuery = window.matchMedia('(max-width: 749px)');
  const guideScrollTimers = new WeakMap();

  const getGuideCards = (track, includeClones = true) => {
    const selector = includeClones
      ? '.guide-grid__card'
      : '.guide-grid__card:not([data-guide-clone])';
    return Array.from(track.querySelectorAll(selector));
  };

  const centerGuideCard = (track, card, behavior = 'smooth') => {
    if (!track || !card) return;
    const left = card.offsetLeft - ((track.clientWidth - card.offsetWidth) / 2);
    track.scrollTo({ left, behavior });
  };

  const getCenteredGuideCard = (track) => {
    const trackCenter = track.scrollLeft + (track.clientWidth / 2);
    return getGuideCards(track).reduce((closest, card) => {
      const cardCenter = card.offsetLeft + (card.offsetWidth / 2);
      const distance = Math.abs(cardCenter - trackCenter);
      return !closest || distance < closest.distance ? { card, distance } : closest;
    }, null)?.card;
  };

  const prepareGuideClone = (card, position) => {
    const clone = card.cloneNode(true);
    clone.setAttribute('data-guide-clone', position);
    clone.setAttribute('aria-hidden', 'true');
    Array.from(clone.attributes).forEach((attribute) => {
      if (attribute.name.startsWith('data-shopify')) clone.removeAttribute(attribute.name);
    });
    clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
    clone.querySelectorAll('a, button, input, select, textarea').forEach((element) => {
      element.setAttribute('tabindex', '-1');
    });
    return clone;
  };

  const prepareGuideSlider = (section) => {
    const track = section.querySelector('[data-guide-track]');
    if (!track) return;

    const originals = getGuideCards(track, false);
    const clones = track.querySelectorAll('[data-guide-clone]');

    if (!guideMobileQuery.matches) {
      clones.forEach((clone) => clone.remove());
      delete track.dataset.guideMobileReady;
      track.scrollLeft = 0;
      return;
    }

    if (originals.length < 2) return;

    if (clones.length === 0) {
      track.prepend(prepareGuideClone(originals[originals.length - 1], 'previous'));
      track.append(prepareGuideClone(originals[0], 'next'));
    }

    if (!track.dataset.guideMobileReady) {
      track.dataset.guideMobileReady = 'true';
      requestAnimationFrame(() => centerGuideCard(track, originals[0], 'auto'));
    }
  };

  const normalizeGuideLoop = (section) => {
    const track = section.querySelector('[data-guide-track]');
    if (!track || !guideMobileQuery.matches) return;

    const centeredCard = getCenteredGuideCard(track);
    const originals = getGuideCards(track, false);
    if (!centeredCard || originals.length < 2) return;

    if (centeredCard.dataset.guideClone === 'previous') {
      centerGuideCard(track, originals[originals.length - 1], 'auto');
    } else if (centeredCard.dataset.guideClone === 'next') {
      centerGuideCard(track, originals[0], 'auto');
    }
  };

  const updateGuideSlider = (section) => {
    const track = section.querySelector('[data-guide-track]');
    const previous = section.querySelector('[data-guide-previous]');
    const next = section.querySelector('[data-guide-next]');
    if (!track || !previous || !next) return;

    if (guideMobileQuery.matches && getGuideCards(track, false).length > 1) {
      previous.disabled = false;
      next.disabled = false;
      return;
    }

    const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    previous.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= maxScroll - 2;
  };

  document.addEventListener('click', (event) => {
    const control = event.target.closest('[data-guide-previous], [data-guide-next]');
    if (!control) return;
    const section = control.closest('[data-guide-slider]');
    const track = section?.querySelector('[data-guide-track]');
    if (!track) return;

    if (guideMobileQuery.matches) {
      const cards = getGuideCards(track);
      const centeredCard = getCenteredGuideCard(track);
      const currentIndex = Math.max(0, cards.indexOf(centeredCard));
      const direction = control.hasAttribute('data-guide-next') ? 1 : -1;
      const target = cards[Math.max(0, Math.min(cards.length - 1, currentIndex + direction))];
      centerGuideCard(track, target);
      return;
    }

    const card = track.querySelector('.guide-grid__card');
    if (!card) return;
    const styles = window.getComputedStyle(track);
    const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
    const direction = control.hasAttribute('data-guide-next') ? 1 : -1;
    track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
  });

  document.addEventListener('scroll', (event) => {
    const track = event.target.closest?.('[data-guide-track]');
    if (!track) return;
    const section = track.closest('[data-guide-slider]');
    updateGuideSlider(section);

    window.clearTimeout(guideScrollTimers.get(track));
    guideScrollTimers.set(track, window.setTimeout(() => {
      normalizeGuideLoop(section);
    }, 120));
  }, true);

  const initializeGuideSliders = () => {
    document.querySelectorAll('[data-guide-slider]').forEach((section) => {
      prepareGuideSlider(section);
      updateGuideSlider(section);
    });
  };

  window.addEventListener('load', initializeGuideSliders);
  window.addEventListener('resize', initializeGuideSliders);
  document.addEventListener('shopify:section:load', initializeGuideSliders);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-social-feed"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('shopify:section:load', function(event) {
    if (!event.target.querySelector('.fym-instagram__official')) return;
    if (window.instgrm && window.instgrm.Embeds) {
      window.instgrm.Embeds.process();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["judgeme-review-entry"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const findWriteReviewControl = () => {
      const widget = document.querySelector('#judgeme_product_reviews, .jdgm-review-widget, .jdgm-widget');
      if (!widget) return null;

      const knownControl = widget.querySelector(
        '.jdgm-write-rev-link, [data-jdgm-write-review], .jdgm-write-review'
      );
      if (knownControl) return knownControl;

      return Array.from(widget.querySelectorAll('a, button')).find((control) =>
        /write\s+a\s+review/i.test(control.textContent || '')
      );
    };

    document.addEventListener('click', (event) => {
      const entry = event.target.closest('[data-fym-judgeme-entry]');
      if (!entry) return;

      const control = findWriteReviewControl();
      if (control) {
        control.click();
        return;
      }

      const widget = document.querySelector('#judgeme_product_reviews, .jdgm-review-widget, .jdgm-widget');
      if (widget) {
        widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
        window.setTimeout(() => findWriteReviewControl()?.click(), 700);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
